import Vue from 'vue';
import moment from 'moment';
import VueMoment from 'vue-moment';
Vue.use(VueMoment, { moment });

import CustomCalendar from './components/CustomCalendar/CustomCalendar.vue';

export default class App {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initialize();
        });
    }

    initialize = () => {
        if (document.getElementById('customCalendar')) {
            let customCalendar = new Vue({
                el: '#customCalendar',
                data: {
                    Vue
                },
                render: h => h(CustomCalendar)
            });
        }
    }
}

window.App = new App();